import Header from '../../components/admin/header/Header'

import Detail from '../../components/admin/review/Detail';

export default function ReviewDetail() {
  return (
    <>
      <Header></Header>
      <Detail />
    </>
  );
}
